
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { useForm } from '../../../../../hooks/useForm';

export const Verificacion = () => {

    const [formValues, handleInputChange, reset] = useForm({

        codigo: '',
    });

    const {codigo } = formValues;


    let validFormFields = () => {

        return true;
    }


    let hanldeSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <div className="login">
            <div className="login_title">
                <h1>CONFIRMAR CUENTA</h1>
            </div>
            <div className="login_formDiv">
                <div className="login_formDiv--desktop">
                    <div className="login_formDiv--desktop--form">
                        <form className="login_form" onSubmit={hanldeSubmit}>
                            <h1>VERIFICACIÓN POR CORREO</h1>
                            <p className="title mb-base">Te enviamos un email a ejemplo@gmail.com con tu código.</p>

                            <input className="login_form--input errorInput" placeholder="Ingresá el código" name="codigo" value={codigo}
                                onChange={handleInputChange} />
                            <p className="errorMsgInput">Por favor ingrese un código válido</p>

                            <button className="login_form--button mt-base" type="submit">Confirmar</button>
                            <div className="login_links my-base">
                                <Link to="">No recibí el código.</Link>
                            </div>
                            <div className="login_form--safe mb-base ">
                                <p className="text-center">Volvimos a enviarte un código.</p>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    )
}
